export const isNonEmptyObject = (obj) => typeof obj === "object" && Object.keys(obj).length > 0;
